import { render } from "./learnerCentral.vue?vue&type=template&id=b5b44a82&scoped=true"
import script from "./learnerCentral.vue?vue&type=script&lang=js"
export * from "./learnerCentral.vue?vue&type=script&lang=js"

import "./learnerCentral.vue?vue&type=style&index=0&id=b5b44a82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b44a82"]])

export default __exports__